<ng-template #modalEmailPreview let-c="close" let-d="dismiss">
  <wsb-modal primaryButtonText="{{ 'common_cancel' | translate }}" (primary)="d()" (dismiss)="d()" title="{{ 'mail_preview' | translate }}">
    <div body>
      <div [innerHtml]="selectedEmailPreview"></div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalConfirmNavigation let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="goToEditor()"
    (dismiss)="d()"
  >
    <div body>
      <div translate>mail_go_back_to_editor</div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalConfirmSend let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="sendEmailCampaign()"
    (dismiss)="d()"
  >
    <div body>
      <div translate>mail_send_confermation</div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalEditTextversion let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="saveNewText()"
    (dismiss)="d()"
    title="{{ 'common_plaintext' | translate }}"
  >
    <div body>
      <textarea [formControl]="textVersion" class="form-control custom-text-area form-control--short h-150"></textarea>
    </div>
  </wsb-modal>
</ng-template>

<h1 class="page__title my-5 h2">{{ 'mail_summary_send_title' | translate }}</h1>

<table class="table table-bordered b-l-none b-r-none">
  <tbody>
    <tr>
      <td class="b-l-none align-top" translate>mail_summary_settings</td>
      <td class="b-r-none">
        <div class="font-weight-bold" translate>common_title</div>
        <span class="f-s-14">{{ emailCampaignIssue?.name }}</span>
        <div class="font-weight-bold" translate>mail_subject</div>
        <span class="f-s-14">{{ emailCampaignIssue?.subject }}</span>

        <div class="font-weight-bold" translate>mail_summary_settings_campaign</div>
        <span class="f-s-14">{{ emailCampaignIssue?.campaign.title }}</span>
      </td>
      <td class="b-x-none text-end">
        <button class="btn btn-custom btn-secondary btn-sm" (click)="editSetup()" translate>
          common_edit
        </button>
      </td>
    </tr>
    <tr>
      <td class="b-l-none align-top" translate>mail_summary_compose</td>
      <td class="b-r-none">
        <div class="font-weight-bold" translate>mail_summary_issuesize</div>
        <span class="f-s-14">{{ size }} {{ 'mail_summary_issuesizekb' | translate }}</span>

        <div class="font-weight-bold" translate>common_plaintext</div>
        <span class="f-s-14 link" (click)="openEditTextversionModal()" translate>mail_summary_plaintext_edit</span>
      </td>
      <td class="b-x-none text-end">
        <div>
          <button class="btn btn-custom btn-secondary mb-3 btn-sm" (click)="openPreviewModal()" translate>
            mail_preview
          </button>
        </div>
        <div>
          <button class="btn btn-custom btn-secondary mb-3 btn-sm" (click)="openNavigationConfemationModal()" translate>
            common_edit
          </button>
        </div>
        <div>
          <button class="btn btn-custom btn-secondary btn-sm" (click)="goToTemplate()" translate>
            mail_change_template
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="b-l-none align-top" translate>mail_recipients</td>
      <td class="b-r-none">
        <div class="font-weight-bold" translate>common_recipients_number</div>
        <span class="f-s-14">{{ emailCampaignIssue?.countRecipients }}</span>
      </td>
      <td class="b-x-none text-end">
        <div>
          <button class="btn btn-custom btn-secondary btn-sm" (click)="goToRecipients()" translate>
            common_edit
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="b-l-none align-top" translate>mail_summary_issueduration</td>
      <td class="b-r-none">
        <div class="font-weight-bold" translate>mail_summary_issueduration</div>
        <span class="f-s-14">{{ duration }} {{ 'mail_summary_minutes' | translate }}</span>
      </td>
      <td class="b-x-none text-end">
        <div translate>
          mail_summary_duration_needmore
          <button class="btn btn-custom btn-secondary ms-3 btn-sm" (click)="goToShop()" translate>
            mail_summary_duration_upgrade
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<h3 class="mt-5" translate>send_sms_send_type_title</h3>

<div class="d-flex justify-content-around mb-80">
  <label class="radio-custom">
    <input [formControl]="scheduleTime" type="radio" [value]="false" />
    <span class="radio-custom__radio"></span>
    <span class="radio-custom__label" translate>mail_summary_sendnow</span>
    <div
      class="tooltip-custom border rounded-circle border-1"
      #tooltip="matTooltip"
      matTooltipPosition="above"
      matTooltipClass="tooltip-class"
      matTooltip="{{ 'send_mail_immediate_help' | translate }}"
    >
      <p>?</p>
    </div>
  </label>

  <label class="radio-custom">
    <input [formControl]="scheduleTime" type="radio" [value]="true" />
    <span class="radio-custom__radio"></span>
    <span class="radio-custom__label" translate>send_mail_posticipated</span>
    <div
      class="tooltip-custom border rounded-circle border-1"
      #tooltip="matTooltip"
      matTooltipPosition="above"
      matTooltipClass="tooltip-class"
      matTooltip="{{ 'send_mail_posticipate_help' | translate }}"
    >
      <p>?</p>
    </div>
  </label>

  <label [formGroup]="scheduledForm" class="time-custom">
    <span class="radio-custom__label" translate>common_data_sent</span>
    <wsb-atlas-datepicker
      [ngClass]="{ disabled: !scheduleTime.value }"
      formControlName="sendDate"
      [min]="today"
      class="w-155 b-t-none ms-2 me-4"
    ></wsb-atlas-datepicker>

    <span class="radio-custom__label" translate>send_mail_send_time</span>
    <input formControlName="sendTime" [ngClass]="{ disabled: !scheduleTime.value }" type="time" class="form-control ms-2 w-155" />
  </label>
</div>
